(function () {
  const jdgmElements = document.querySelectorAll(
    ".jdgm-widget:not(.jdgm-all-reviews-text), .jdgm-all-reviews-page, .jdgm-carousel-wrapper, #judgeme_product_reviews"
  );

  // Review invitation links (e.g. the "Jetzt bewerten" link in the Klaviyo review e-mail)
  // carry these parameters. Judge.me only evaluates them while it initialises - if we lazy
  // load the widget, the visitor just lands on top of the product page and nothing happens.
  const REVIEW_INVITATION_PARAMS = ["judgeme_review_source", "judgeme_token"];
  const isReviewInvitationLink = (() => {
    const searchParams = new URLSearchParams(window.location.search);
    return REVIEW_INVITATION_PARAMS.some((param) => searchParams.has(param));
  })();

  if (jdgmElements.length > 0) {
    let jdgmInitialised = false;
    const initJudgeMe = () => {
      if (jdgmInitialised) return;
      // execute jdgm assets
      const jdgmScript = document.getElementsByClassName("jdgm-script");
      if (jdgmScript.length === 0) return;
      jdgmInitialised = true;
      Function(jdgmScript[0].textContent)();
      window.TitusJdgmHelper.load();
      window.TitusObjectObserver.observeCustom(() => {
        return document.querySelector(
          "section.jdgm-carousel--done,.jdgm--done-setup-widget,jdgm--done-setup"
        );
      })
        .catch(() => {})
        .finally(() => {
          jdgmElements.forEach((jdgmElement) => {
            window.removeLoader(jdgmElement);
          });
        });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // remove observer
            observer.disconnect();
            initJudgeMe();
          }
        });
      },
      {
        rootMargin:
          window.screen && window.screen.availWidth > 600 ? "250px" : "500px",
      }
    );

    jdgmElements.forEach((jdgmElement) => {
      // add intersection observer to jdgmElement
      // exclude jdgm-preview-badge, we're handling this differently - see below
      if (!jdgmElement.classList.contains("jdgm-preview-badge")) {
        observer.observe(jdgmElement);
        // add loader
        window.generateLoader(jdgmElement);
      }
      // handle jdgm-preview-badge that does not show review count text without the jdgm app
      if (jdgmElement.classList.contains("jdgm-preview-badge")) {
        if (!jdgmElement.querySelector(".jdgm-prev-badge")) return;
        const count =
          jdgmElement.querySelector(".jdgm-prev-badge").dataset.numberOfReviews;
        const countEl = jdgmElement.querySelector(".jdgm-prev-badge__text");
        if (jdgmSettings.badge_hide_text || !countEl) return;
        if (count) {
          let text = jdgmSettings.badge_n_reviews_text;
          const split = text.split("{{ n }} ");
          split.forEach((item, index) => {
            if (count == 1) {
              split[index] = item.split("/")[0];
            } else {
              split[index] = item.split("/")[1];
            }
          });
          text = split.join("{{ n }} ").replace("{{ n }}", count);
          countEl.textContent = text;
        } else {
          countEl.textContent = jdgmSettings.badge_no_review_text;
        }
        countEl.style.visibility = "visible";
      }
      // add product images to product reviews widget
      const addProductImages = () => {
        const elements = jdgmElement.querySelectorAll('.jdgm-rev[data-product-url]');
        if (elements.length > 0) {
          elements.forEach((element) => {
            const productUrl = element.dataset.productUrl;
            const productTitle = element.dataset.productTitle;
            const titleHandle = productTitle.split(' ').join('-').toLowerCase();
            const colorHandle = productUrl.split(titleHandle)[1];
            let variantPickerLink = document.querySelector('a.opt-label--image[href*="' + colorHandle + '"]');
            if (!variantPickerLink) {
              variantPickerLink = document.querySelector('a.opt-label--image');
            }
            const img = variantPickerLink.querySelector('img');
            if (img) {
              const imgSrc = img.getAttribute('src');
              const imgAlt = img.getAttribute('alt');
              const imgElement = document.createElement('img');
              imgElement.setAttribute('src', imgSrc);
              imgElement.setAttribute('alt', imgAlt);
              imgElement.classList.add('jdgm-product-image');
              const innerHTML = element.innerHTML;
              const newHtml = '<div style="margin-right: 12px; width: 87px; flex: none;">' + imgElement.outerHTML + '</div><div class="flex-auto">' + innerHTML + '</div>';
              element.innerHTML = newHtml;
              element.classList.add('flex', 'items-center');
            }
          });
        }
      }
      if (jdgmElement.id === 'judgeme_product_reviews') {
        addProductImages();

        // mutation observer on .jdgm-rev-widg__body
        const targetNode = jdgmElement.querySelector('.jdgm-rev-widg__body');
        const config = { attributes: false, childList: true, subtree: false };
        const observer = new MutationObserver((mutationsList, observer) => {
          for (const mutation of mutationsList) {
            addProductImages();
          }
        });
        observer.observe(targetNode, config);
      }
    });

    // visitors coming from a review invitation link must not wait for the lazy loading
    if (isReviewInvitationLink) {
      observer.disconnect();
      initJudgeMe();
    }
  }

  // Fix for Judge.me reviews scroll to reviews with sticky header
  const reviewContainerSelector = ".template-product #judgeme_product_reviews";
  const reviewStarsSelector = ".product-info__block .jdgm-preview-badge";
  const mainMenuSelector = ".template-product .main-menu__content";
  const reviewStars = document.querySelector(reviewStarsSelector);
  const reviewContainer = document.querySelector(reviewContainerSelector);
  const mainMenu = document.querySelector(mainMenuSelector);

  if (reviewStars && reviewContainer && mainMenu) {
    const parentElement = reviewStars.parentElement;
    reviewContainer.querySelector('.jdgm-rev-widg > .jdgm-temp-hiding-style').remove();

    reviewStars.style.pointerEvents = "none";
    parentElement.style.cursor = "pointer";

    const listener = () => {
      let headerHeight = parseInt(getComputedStyle(document.querySelector('store-header')).getPropertyValue("--menu-height") || "0");
      let bodyHeight = document.body.clientHeight;
      let windowHeight = window.innerHeight;
      if (windowHeight < headerHeight) {
        headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height") || "0");
      }
      let reviewContainerPosition = reviewContainer.getBoundingClientRect().top;
      let calculatedScrollToPosition = reviewContainerPosition - headerHeight;

      if ((calculatedScrollToPosition + windowHeight) > bodyHeight) {
        document.body.style.setProperty('--jdgm-height-fix', `${calculatedScrollToPosition + windowHeight - bodyHeight}px`);
      }

      window.scrollBy({
        top: calculatedScrollToPosition,
        behavior: "smooth",
      });
    }

    parentElement.addEventListener("click", async () => {
      // check what lazy elements come before the reviews
      const mainContentEl = document.querySelector("#main-content");
      const childrenArr = Array.from(mainContentEl.children);
      const recIndex = childrenArr.indexOf(document.querySelector('section:has(product-recommendations)'));
      const lastIndex = childrenArr.indexOf(document.querySelector('section:has(recently-viewed)'));
      const jdgmIndex = childrenArr.indexOf(document.querySelector('section:has(#judgeme_product_reviews)'));

      // unobserve lazy elements
      if (jdgmIndex > recIndex && recIndex !== -1) {
        prodRecEl = document.querySelector('product-recommendations');
        prodRecEl.unobserve();
      }

      if (jdgmIndex > lastIndex && lastIndex !== -1) {
        recViewEl = document.querySelector('recently-viewed');
        recViewEl.unobserve();
      }

      // scroll to reviews
      listener();

      if (!document.querySelector("section.jdgm-carousel--done,.jdgm--done-setup-widget,jdgm--done-setup")) {
        // init lazy elements after scroll, which otherwise can mess with the scroll distance
        // we need to wait for the scroll to finish and use jdgm--done-setup-widget as a trigger because it's unlikely jdgm initializes before the scroll finishes
        window.TitusObjectObserver.observeCustom(() => {
          return document.querySelector(
            "section.jdgm-carousel--done,.jdgm--done-setup-widget,jdgm--done-setup"
          );
        })
          .catch(() => {})
          .finally(() => {
            prodRecEl.init();
            recViewEl.init();
          });
      }
    });
  }

  // Fix for Judge.me "write a review" form scroll with sticky header
  // Judge.me animates the page so that `.jdgm-form-wrapper` ends up at viewport top (y = 0).
  // It does not know about our sticky header, so the form heading and the star rating end up
  // hidden behind it. We wait until the form is expanded and Judge.me's own scroll animation
  // has finished, then re-align the form with scrollIntoView(), which honours the global
  // `scroll-padding-top: var(--header-height)`.
  const WRITE_REVIEW_TRIGGER_SELECTOR = ".jdgm-write-rev-link";
  const FORM_WRAPPER_SELECTOR = ".jdgm-form-wrapper";
  const OPEN_POLL_INTERVAL = 50;
  // Judge.me scrolls right after the click and - when the form is still rendering - once
  // more afterwards, so we re-check a few times instead of correcting only once.
  const ALIGN_ATTEMPT_DELAYS = [600, 1500, 3000, 5000];
  const ALIGN_TOLERANCE = 4;

  const getStickyHeaderOffset = () =>
    parseInt(
      getComputedStyle(document.documentElement).getPropertyValue(
        "scroll-padding-top"
      ),
      10
    ) || 0;

  // Waits for the review form to be expanded and then makes sure it is not sitting behind
  // the sticky header. Aborts as soon as the visitor interacts with the page themselves.
  const alignReviewFormWithStickyHeader = (widget, timeout) => {
    let cancelled = false;
    const cancel = () => {
      cancelled = true;
    };
    const userEvents = ["wheel", "touchstart", "keydown", "mousedown"];
    userEvents.forEach((type) =>
      window.addEventListener(type, cancel, { passive: true })
    );
    const releaseUserEvents = () =>
      userEvents.forEach((type) => window.removeEventListener(type, cancel));

    const startedAt = Date.now();

    const interval = setInterval(() => {
      if (cancelled || Date.now() - startedAt > timeout) {
        clearInterval(interval);
        return releaseUserEvents();
      }

      const formWrapper = widget.querySelector(FORM_WRAPPER_SELECTOR);
      const isOpen =
        formWrapper &&
        formWrapper.getBoundingClientRect().height > 0 &&
        getComputedStyle(formWrapper).display !== "none";
      if (!isOpen) return;

      clearInterval(interval);

      ALIGN_ATTEMPT_DELAYS.forEach((delay, index) => {
        setTimeout(() => {
          if (index === ALIGN_ATTEMPT_DELAYS.length - 1) releaseUserEvents();
          if (cancelled) return;
          // only correct when Judge.me pulled the form up behind the sticky header
          const isBehindHeader =
            formWrapper.getBoundingClientRect().top <
            getStickyHeaderOffset() - ALIGN_TOLERANCE;
          if (!isBehindHeader) return;
          formWrapper.scrollIntoView({ behavior: "smooth", block: "start" });
        }, delay);
      });
    }, OPEN_POLL_INTERVAL);
  };

  document.addEventListener(
    "click",
    (event) => {
      const trigger =
        event.target.closest && event.target.closest(WRITE_REVIEW_TRIGGER_SELECTOR);
      if (!trigger) return;
      alignReviewFormWithStickyHeader(
        trigger.closest("#judgeme_product_reviews") || document,
        3000
      );
    },
    true
  );

  // Judge.me opens and scrolls to the form on its own when the page is opened through a
  // review invitation link - that scroll ignores the sticky header as well. The widget is
  // loaded asynchronously here, so we allow a longer window.
  if (isReviewInvitationLink) {
    alignReviewFormWithStickyHeader(
      document.querySelector("#judgeme_product_reviews") || document,
      15000
    );
  }

  // Scroll back to the review widget after a review was submitted
  // Judge.me replaces the form with a much shorter confirmation ('.jdgm-notification'),
  // so the page collapses underneath the visitor and they end up in the footer.
  const NOTIFICATION_SELECTOR = ".jdgm-notification";
  // the form collapses right after the confirmation is rendered - let the layout settle
  const NOTIFICATION_LAYOUT_BUFFER = 400;

  const reviewWidget = document.querySelector("#judgeme_product_reviews");
  if (reviewWidget) {
    let handledNotification = null;

    new MutationObserver(() => {
      const notification = reviewWidget.querySelector(NOTIFICATION_SELECTOR);
      if (!notification) {
        handledNotification = null;
        return;
      }
      if (notification === handledNotification) return;
      handledNotification = notification;

      setTimeout(() => {
        // only pull the visitor back up if the widget scrolled out of view above them
        const isAboveViewport =
          reviewWidget.getBoundingClientRect().top <
          getStickyHeaderOffset() - ALIGN_TOLERANCE;
        if (!isAboveViewport) return;
        reviewWidget.scrollIntoView({ behavior: "smooth", block: "start" });
      }, NOTIFICATION_LAYOUT_BUFFER);
    }).observe(reviewWidget, { childList: true, subtree: true });
  }
})();
